<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <!-- Search By Date Range -->
                    <date-picker
                            v-model="search.date"
                            lang="en"
                            placeholder="ระหว่างวันที่ ~ ถึงวันที่"
                            range></date-picker>&nbsp

                    <button @click="searchPayment"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">เลขใบวางบิล</th>
                    <th scope="col">เลขที่ใบจอง</th>
                    <th scope="col">จำนวนเงิน</th>
                    <th scope="col">วันที่</th>
                    <!--<th width="1" scope="col">ดูข้อมูล</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="(payment, index) in payments">
                    <td>
                        <template v-if="payment.billing">
                            {{payment.billing.no}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="payment.order">
                            {{payment.order.order_id}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ payment.total_amount | currency }}</td>
                    <td>{{ payment.created_at | moment("DD/MM/YYYY") }}</td>
                    <!--<td>-->
                        <!--<button class="btn btn-primary"-->
                                <!--@click="showPaymentModal(payment.id)">-->
                            <!--<span> บันทึกรับ</span>-->
                        <!--</button>&nbsp-->
                    <!--</td>-->
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="payments.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="setPayment">
            </vue-pagination>
        </div>
        <pre class="alert-danger text-left">{{payments}}</pre>
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import moment from "moment"
    import VuePagination from "../../Pagination"
    import DatePicker from 'vue2-datepicker'

    import Modal from "bootstrap-vue/es/components/modal/modal"

    export default {
        components: {
            VuePagination,
            Modal,
            DatePicker
        },
        name: "payments",
        data() {
            return {
                search: {
                    date: ""
                }
            }
        },
        created() {
            this.setPayment()
            this.search = {
                date: [
                    moment(this.$store.state.Payment.search.start_date).toDate(),
                    moment(this.$store.state.Payment.search.end_date).toDate()
                ]
            }
        },
        computed: {
            ...mapState({
                payments: state => {
                    return state.Payment.payments
                },
                dataPaginate:state=>{
                    return state.Payment.dataPaginate;
                }
            })
        },
        methods: {
            setPayment() {
                this.$store.dispatch("Payment/setPayments")
            },
            searchPayment() {
                this.$store.dispatch("Payment/setSearch", {
                    start_date: moment(this.search.date[0]).format('YYYY-MM-DD'),
                    end_date: moment(this.search.date[1]).format('YYYY-MM-DD')
                })
                    .then(() => this.setPayment())
            }
        }
    }
</script>

<style lang="scss" scoped>
    .select {
        border: 0;
    }

    table {
        tr {
            th {
                vertical-align: middle;
            }
            td, th {
                white-space: nowrap;
            }
        }
    }
</style>